export function normalizeRoleNames(roles) {
  return (Array.isArray(roles) ? roles : []).map((x) => String(x || "").trim().toLowerCase());
}

export function normalizePermissionCodes(permissions) {
  if (!Array.isArray(permissions)) return [];
  return permissions.map((p) => {
    if (typeof p === "string") return p;
    if (p && typeof p.code === "string") return p.code;
    return "";
  }).map((x) => String(x || "").trim()).filter(Boolean);
}

export function hasAnyRole(user, roleNames) {
  const roles = normalizeRoleNames(user?.roles);
  return roleNames.some((r) => roles.includes(String(r || "").trim().toLowerCase()));
}

export function hasPermission(user, code) {
  if (hasAnyRole(user, ["admin"])) return true;
  const perms = normalizePermissionCodes(user?.permissions);
  return perms.includes(code);
}

export function hasAnyPermission(user, codes) {
  if (hasAnyRole(user, ["admin"])) return true;
  const perms = normalizePermissionCodes(user?.permissions);
  return codes.some((c) => perms.includes(c));
}
